import React from 'react';
import { SlideLayout } from './SlideLayout';
import { ExternalLink } from 'lucide-react';
export function Slide5_Proof() {
  const stats = [{
    market: 'Windows (Western U.S.)',
    company: '4 offices, 50+ reps',
    metrics: ['175 hires', '4 months', '3 new markets'],
    highlight: '175'
  }, {
    market: 'Life Insurance',
    company: 'Multi-market senior benefits',
    metrics: ['120+ hires', 'Scalable system', 'Multi-state expansion'],
    highlight: '120+'
  }, {
    market: 'Pest Control (TN)',
    company: 'Regional expansion',
    metrics: ['65 hires', '<$200 per hire', 'High retention'],
    highlight: '65'
  }, {
    market: 'Solar (Northeast)',
    company: 'Market entry',
    metrics: ['126 hires', 'Predictable pipeline', 'Zero admin'],
    highlight: '126'
  }, {
    market: 'Roofing (GA)',
    company: 'Rapid ramp',
    metrics: ['24 hires', 'First 30 days', 'Full capacity'],
    highlight: '24'
  }, {
    market: 'Home Services',
    company: 'Multi-location',
    metrics: ['85 hires', '6 markets', 'Consistent quality'],
    highlight: '85'
  }];
  return <SlideLayout data-id="element-125">
      <div className="flex flex-col h-full justify-center space-y-8" data-id="element-126">
        <div className="text-center" data-id="element-127">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" data-id="element-128">
            Real companies, real results, predictable recruiting systems in
            action.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-129">
          {stats.map((stat, idx) => <div key={idx} className="bg-slate-900 p-6 rounded-xl border border-slate-800 flex flex-col justify-between group hover:border-emerald-500/30 transition-colors" data-id="element-130">
              <div className="mb-6" data-id="element-131">
                <h3 className="text-lg font-bold text-white mb-1" data-id="element-132">
                  {stat.market}
                </h3>
                <p className="text-sm text-slate-500" data-id="element-133">{stat.company}</p>
              </div>

              <div className="space-y-4" data-id="element-134">
                <div className="text-5xl font-bold text-white" data-id="element-135">
                  {stat.highlight}{' '}
                  <span className="text-xl text-emerald-400 font-normal" data-id="element-136">
                    hires
                  </span>
                </div>
                <div className="flex flex-wrap gap-2" data-id="element-137">
                  {stat.metrics.slice(1).map((metric, mIdx) => <span key={mIdx} className="inline-flex items-center px-3 py-1 rounded-full bg-slate-800 text-slate-300 text-xs border border-slate-700" data-id="element-138">
                      {metric}
                    </span>)}
                </div>
              </div>
            </div>)}
        </div>

        <div className="flex justify-center mt-6" data-id="element-139">
          <a href="https://thehireadvantage.co/case-studies" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-8 py-4 bg-amber-500 hover:bg-amber-600 text-slate-950 font-bold rounded-lg transition-all transform hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl" data-id="element-140">
            <span data-id="element-141">Case Studies and Testimonials</span>
            <ExternalLink className="ml-2 w-5 h-5" data-id="element-142" />
          </a>
        </div>
      </div>
    </SlideLayout>;
}